import { Breakpoint, Breakpoints, Theme } from '@mui/material'

type ThemeFunction = (props: { theme: Theme }) => string

type Constraint = keyof Pick<
  Breakpoints,
  'up' | 'down' | 'between' | 'only' | 'not'
>

export function media(
  constraint: 'up' | 'down',
  breakpoint: Breakpoint | number,
): ThemeFunction

export function media(
  constraint: 'only' | 'not',
  breakpoint: Breakpoint,
): ThemeFunction

export function media(
  constraint: 'between',
  breakpoint: Breakpoint | number,
  end: Breakpoint | number,
): ThemeFunction

export function media(
  constraint: Constraint,
  // oxlint-disable-next-line typescript/no-explicit-any
  breakpoint: any,
  // oxlint-disable-next-line typescript/no-explicit-any
  end?: any,
): ThemeFunction {
  return (props: { theme: Theme }) =>
    props.theme.breakpoints[constraint](breakpoint, end)
}

export function spacing(unit: string) {
  return [...new Array(12)]
    .reduce((a, _, i) => {
      const n = i + 1
      return [...a, `--spacing-${n}: calc(${n} * ${unit});`]
    }, [])
    .join('\n')
}

export const globalStyles = `
  @keyframes rotateLinear {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  :root {
    --loader-spin: rotateLinear 1.5s linear infinite;
  }
`

export const getAssetClassColorMapping = (
  assetClass: string | null,
): string => {
  switch (assetClass) {
    case 'Fixed Interest - United Kingdom':
      return '#389999'
    case 'Fixed Interest - Overseas':
      return '#016E6F'
    case 'Equities - United Kingdom':
      return '#5CAB63'
    case 'Equities - UK and Europe':
      return '#1D7721'
    case 'Equities - Europe ex UK':
    case 'Equities - Europe (ex UK)':
      return '#D567A0'
    case 'Equities - North America':
      return '#F05C00'
    case 'Equities - Japan':
      return '#751D69'
    case 'Equities - Asia Pacific ex Japan':
    case 'Equities - Asia Pacific (ex Japan)':
      return '#496BF1'
    case 'Equities - Emerging Markets':
      return '#AB72E9'
    case 'Equities - Global':
      return '#1C5490'
    case 'Alternative Investments':
      return '#E5499A'
    case 'Cash':
      return '#4D8FD1'
    case 'Cash Products':
      return '#085D30'
    default:
      return '#023843'
  }
}
